import { useState } from "react";
import InlineWarning from "./InlineWarning";
import LinkContactModal from "../modals/LinkContactModal";

interface InlineContactFormProps {
  clientId: string;
  clientName?: string;
  entityType?: string;
  existingLinkedContacts?: any[];
  warningMessage?: string;
  onSuccess: () => void;
}

/**
 * InlineContactForm
 *
 * Shows an InlineWarning banner with an "+ Add a contact" button.
 * Clicking the button opens the shared LinkContactModal (which supports
 * both linking an existing contact and creating a new one).
 *
 * Usage:
 *   <InlineContactForm
 *     key={clientId}
 *     clientId={clientId}
 *     clientName={client.name}
 *     entityType={client.entityType}
 *     existingLinkedContacts={linkedContacts}
 *     onSuccess={handleRefresh}
 *   />
 */
export default function InlineContactForm({
  clientId,
  clientName = "this client",
  entityType,
  existingLinkedContacts = [],
  warningMessage = "This client has no contacts yet.",
  onSuccess,
}: InlineContactFormProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <InlineWarning
        message={warningMessage}
        action={{ label: "+ Add a contact", onClick: () => setOpen(true) }}
      />
      <LinkContactModal
        open={open}
        onClose={() => setOpen(false)}
        onSave={() => {
          setOpen(false);
          onSuccess();
        }}
        clientId={clientId}
        clientName={clientName}
        entityType={entityType}
        existingLinkedContacts={existingLinkedContacts}
      />
    </>
  );
}
